import { apiCall } from "@/common/api/ApiResult.model";
import { AuditInput, AuditItem } from "./models";
import { ListResult } from "@/common/models";
import { delayBy } from "@/fp";
import { ICONS } from "@/common/icons.map";
import { SharedState } from "@/common/state";
import { APPLICATIONS_MAP } from "@/views/customize/data-sources/data/data-relations/applicaitons.map";
import { DATA_SOURCES_MAP } from "@/views/customize/data-sources/data/data-relations/data-sources.map";
import { FindingsHelper } from "@/common/api/findings/findings.model";
import { audit_list } from "./data.mock";

export const get_playbook_audit = apiCall<AuditInput, ListResult<AuditItem>>(
  "playbook.audit",
  async ({ cursor }) => {
    await delayBy(1000);
    return {
      success: true,
      value: {
        cursor: "",
        objects: audit_list.map((d, index) => {
          const label = SharedState.allInfoTypes.value[d.information];
          return {
            ...d,
            id: "playbook_" + index,
            information: {
              icon: ICONS.L0_ICONS.get(label.code),
              id: label.id,
              name: label.labelName,
            },
            data_source: {
              id: d.date_source,
              name: DATA_SOURCES_MAP[d.date_source].name,
              icon: DATA_SOURCES_MAP[d.date_source].icon,
            },
            application: {
              id: d.application,
              name: APPLICATIONS_MAP[d.application].display_name,
              icon: ICONS.APPLICATIONS.get(d.application),
            },
            findings: {
              ...d.findings,
              sentence: FindingsHelper.to_sentence(d.findings.id),
            },
          };
        }),
      },
    };
  }
);
